import Handlebars from 'handlebars';
import toastr from 'toastr';
import Settings from '~/settings.js';
import EventHub from '~/eventHub';
import adminlanguages_template from '~/templates/adminLanguages.handlebars';
import table_template from '~/templates/adminLanguages-table.handlebars';
import getLocalizationService from '~/services/localizationService';
import GeneralView from '~/generalView';

var AdminLanguagesView = GeneralView.View.extend({
	tagName: "div",
	className: 'admin-languages',
	lang: null,
	qtys: [],
    events: {
		'change #languages' : 'languageChange',
		'click #savestaticlang' : 'saveStaticLang',
		'click #addnewstaticlang' : 'addNewEntry',
		'click .deleteStaticLang' : 'deleteEntry',
		'click #savenewlanguage' : 'createNewLanguage',
		'click #saveeditlanguage' : 'editLanguage',
		'click #deletelanguage' : 'deleteLanguage',
		'click #openeditlangmodal' : function(){this.openCreateLangModal(false)},
		'click #opencreatelangmodal' : function(){this.openCreateLangModal(true)},
	},

	render: function () {
		var that = this;
		getLocalizationService().getLanguages().then(function(query){
			var handlebarsTemplate = Handlebars.template(adminlanguages_template);
			that.$el.html(handlebarsTemplate({languages: query}));
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		return this;
	},

	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

	languageChange: function(e){
		var that = this;
		var value = e.currentTarget.value;
		$("#openeditlangmodal").prop("disabled", false);
		$("#deletelanguage").prop("disabled", false);
		getLocalizationService().getLanguageStaticLang(value).then((result) => {
			var langJson = JSON.parse(result.attributes.staticlang);
			that.lang = value;
			var handlebarsTemplate = Handlebars.template(table_template);
			$("#static-lang").html(handlebarsTemplate({langs: langJson}));
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	saveStaticLang: function(){
		var inputs = $('.inputStaticLang');
		var newStaticLang = {};
		for(var i=0; i < inputs.length; i++){
			var key = $(inputs[i]).data('key');
			var value = $(inputs[i]).val();
			newStaticLang[key] = value;
		}
		var staticLangString = JSON.stringify(newStaticLang);
		getLocalizationService().updateLanguageStaticLang(this.lang, staticLangString);
	},

	addNewEntry: function(){
		var entry = $("#newStaticEntry").val().trim();
		entry = entry.replace(/\s+/g, '');
		if(entry){
			var $clone = $(".newEntryClone").clone().removeClass("newEntryClone");
			$clone.find('input').attr('data-key', entry).addClass("inputStaticLang");
			$clone.prepend('<td>'+ entry +'</td>');
			$clone.insertBefore('#staticLangInsertRow');
		}
	},

	deleteEntry: function(e){
		$(e.target).parents().remove("tr");
	},

	createNewLanguage: function(){
		var name = $("#newlangname").val().trim();
		var abbr = $("#newlangabbreviation").val().trim();
		if(name && abbr){
			getLocalizationService().createNewLanguage(name, abbr, (newLang) => {
				var $clone = $("#languages option").last().clone().val(newLang.id).text(newLang.attributes.name).prop('disabled', false);
				$("#languages").append($clone);
				$("#languages").val(newLang.id);
				$("#languages").change();
				toastr.success("Lenguaje Creado", "Operación realizada");
			});
		}
	},

	editLanguage: function(){
		var name = $("#newlangname").val().trim();
		var abbr = $("#newlangabbreviation").val().trim();
		if(name && abbr){
			getLocalizationService().editLanguage(this.lang, name, abbr, (editedLang) => {
				$('#languages option[value="'+editedLang.id+'"]').text(editedLang.attributes.name);
				toastr.success("Cambios guardados", "Operación realizada");
			});
		}
	},

	deleteLanguage: function(){
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["DeleteLanguage"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonNewPswd(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonNewPswd();
		});
	},
	
	acceptButtonDelLanguage: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		getLocalizationService().deleteLanguage(this.lang, (oldLang) => {
			$("#languages").val($("#languages option").first().val());
			$('#languages option[value="'+oldLang.id+'"]').remove();
			$("#static-lang").empty();
			$("#openeditlangmodal").prop("disabled", true);
			$("#deletelanguage").prop("disabled", true);
			toastr.success("Lenguaje elminado con exito", "Operación realizada");
		});
	},
	
	cancelButtonDelLanguage: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	openCreateLangModal: function(isNew){
		if(isNew){
			$("#savenewlanguage").removeClass("hidden");
			$("#saveeditlanguage").addClass("hidden");
			$("#newlangname").val("");
			$("#newlangabbreviation").val("")
		} else {
			$("#savenewlanguage").addClass("hidden");
			$("#saveeditlanguage").removeClass("hidden");
			getLocalizationService().getLanguage(this.lang).then(function(query){
				var name = query.attributes.name;
				var abbr = query.attributes.abbreviation;
				$("#newlangname").val(name);
				$("#newlangabbreviation").val(abbr)
			},
			function(error){
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		}
	}

});
export default AdminLanguagesView;
